import storageLocal from 'redux-persist/es/storage';
import { REDUCER_NAME_BASIC_INFO } from './reducers';

export const basicInfoPersistConfig = {
  key: `CollegeProfileReact.${REDUCER_NAME_BASIC_INFO}`,
  storage: storageLocal,
};

export default {
  key: 'root',
  storage: storageLocal,
  blacklist: ['routing', 'nonPersistedCollegeProfile', REDUCER_NAME_BASIC_INFO],
};
